
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'
import LedgetApi from './src/LedGet'


let apis = {
   TranResourcesApi,
   RegionList,
   LedgetApi
};

export default apis;
